import { MonitorDot, UserRound, User, FileText, BookOpen, MessageSquare, HelpCircle, Settings, Library, Sheet, Smartphone, Bot } from "lucide-react";

const menuData: any = [
    {
        label: 'menu',
        isTitle: true,
    },
    {
        id: "dashboard",
        label: 'Dashboard',
        link: "/",
        icon: <MonitorDot />,
    },
    {
        label: 'Core',
        isTitle: true,
    },
    {
        id: "students",
        label: 'Students',
        link: "/students",
        icon: <UserRound />,
        parentId: 2
    },
    {
        id: "coaches",
        label: 'Coaches',
        link: "/coaches",
        icon: <User />,
        parentId: 2
    },
    {
        id: "schools",
        label: 'Schools',
        link: "/schools",
        icon: <Library />,
        parentId: 2
    },
    {
        id: "groups",
        label: 'Groups',
        link: "/groups",
        icon: <MessageSquare />,
        parentId: 2
    },
    {
        id: "programs",
        label: 'Programs',
        link: "/programs",
        icon: <BookOpen />,
        parentId: 2
    },
    {
        id: "resources",
        label: 'Resources',
        link: "/resources",
        icon: <FileText />,
        parentId: 2
    },
    {
        id: "avatars",
        label: 'Avatars',
        link: "/avatars",
        icon: <User />,
        parentId: 2
    },
    {
        label: 'General',
        isTitle: true,
        className: 'mt-4'
    },
    {
        id: "hope",
        label: 'Hope AI',
        link: "/hope",
        icon: <Bot />,
        parentId: 3
    },
    {
        id: "faq",
        label: 'FAQs',
        link: "/faqs",
        icon: <HelpCircle />,
        parentId: 3
    },
    {
        id: "settings",
        label: 'Settings',
        link: "/settings",
        icon: <Settings />,
        parentId: 3
    },
    {
        id: "landingpage",
        label: 'Apps Download',
        link: "https://theyunion.org/apps",
        icon: <Smartphone />,
        parentId: 3,
        isExternal: true
    },
    {
        id: "googlesheet",
        label: 'Google Sheet',
        link: import.meta.env.REACT_APP_GOOGLE_SHEET_URL || "https://google.com",
        icon: <Sheet />,
        parentId: 3,
        isExternal: true
    },
];

export { menuData };
